(function () {
  if (typeof __webpack_require__ !== 'undefined') {
    var oldGetScript = __webpack_require__.u;
    var oldLoadScript = __webpack_require__.e;
    var queryMap = {};
    var countMap = {};
    var cssCountMap = {};

    var getRetryDelay = function () {
      return 3000;
    };
    __webpack_require__.u = function (chunkId) {
      var result = oldGetScript(chunkId);
      return (
        result +
        (queryMap.hasOwnProperty(chunkId) ? '?' + queryMap[chunkId] : '')
      );
    };

    var webpackMiniF = __webpack_require__.miniCssF;

    __webpack_require__.miniCssF = function (chunkId) {
      return (
        webpackMiniF(chunkId) +
        (queryMap.hasOwnProperty(chunkId) ? '?' + queryMap[chunkId] : '')
      );
    };

    __webpack_require__.e = function (chunkId) {
      var result = oldLoadScript(chunkId);
      return result.catch(function (error) {
        console.warn('webpack load error', error);
        var isJs = error.message.indexOf('Loading CSS chunk') === -1;
        var retries = 0;
        if (isJs) {
          retries = countMap.hasOwnProperty(chunkId) ? countMap[chunkId] : 10;
        } else {
          retries = cssCountMap.hasOwnProperty(chunkId)
            ? cssCountMap[chunkId]
            : 10;
        }
        if (retries < 1) {
          var realSrc = isJs ? oldGetScript(chunkId) : webpackMiniF(chunkId);
          error.message =
            'Loading' + isJs
              ? ''
              : 'CSS' +
                'chunk ' +
                chunkId +
                ' failed after 10 retries.\n(' +
                realSrc +
                ')';
          error.request = realSrc;
          throw error;
        }
        return new Promise(function (resolve) {
          var retryAttempt = 10 - retries + 1;
          setTimeout(function () {
            var retryAttemptString = '&retry-attempt=' + retryAttempt;
            var cacheBust = (function () {
              return Date.now();
            })();
            +retryAttemptString;
            if (isJs) {
              queryMap[chunkId] = cacheBust;
              countMap[chunkId] = retries - 1;
            } else {
              queryMap[chunkId] = cacheBust;
              cssCountMap[chunkId] = retries - 1;
            }
            resolve(__webpack_require__.e(chunkId));
          }, getRetryDelay(retryAttempt));
        });
      });
    };
  }
})();
